export default function getEquipmentInnerId(id){

  //console.log(window.config.nodes[id])
  //return window.config.app_map[id] || id
  return window.config.nodes[id] ? window.config.nodes[id].caption : id;
}
